module.exports = __webpack_public_path__ + "img/01.572375f9.jpg";